import { useContext } from 'react';
import DistributionPointSelected from '../../context/MyDistributionPoint';
import DictumsTable from './components/DictumsTable';


export default function DictumsPage({ history }) {

  const { distributionPoint } = useContext(DistributionPointSelected);

  return (
    <>
      <DictumsTable distributionPoint={distributionPoint} history={history} />
    </>
  );
}
